import React from 'react';

import cs from 'classnames';
import moment, {Moment, MomentInput} from 'moment-tz';

import {SweetDatePicker} from 'app/general/widgets/SweetDatePicker';
import {gt} from 'app/utils/i18n';

interface Props {
  due: string | null;
  onChange: (due: string) => unknown;
  lockDueDate: boolean;
  tz: string;
}

export function DueDateInputField({
  due,
  onChange,
  lockDueDate,
  tz,
}: Props): JSX.Element {
  function restoreTime(date: Date): Date {
    let newDue = moment.tz(date, tz);

    if (due != null) {
      let prevDue = moment.tz(due, tz);
      newDue = newDue.hour(prevDue.hour()).minute(prevDue.minute());
    }

    return newDue.toDate();
  }

  return (
    <SweetDatePicker
      format="ll"
      className={cs('form-control', {
        disabled: lockDueDate,
      })}
      value={getDateInTz(due, tz).toDate()}
      placeholder={gt('Due Date')}
      disabled={lockDueDate}
      onChange={(dates) => onChange(restoreTime(dates[0]).toISOString())}
    />
  );
}

function getDateInTz(date: MomentInput, tz: string): Moment {
  // if there is not date, moment(undefined) will return now
  return moment(date !== null ? date : undefined).tz(tz);
}
